<template>
  <div :class="[$style.wrapper, 'dashboard-widget-setting-side']">
    <div :class="$style['no-data']" v-show="this.activeWidgets.length < 1">
      위젯을 선택해주십시오.
    </div>
    <div v-show="this.activeWidgets.length > 0" style="height: 100%;" class="tab-wrapper origin">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="기본" :name="DashboardConst.WIDGET_SET_TYPE.BASE"></el-tab-pane>
        <el-tab-pane label="데이터" :name="DashboardConst.WIDGET_SET_TYPE.DATA"></el-tab-pane>
        <el-tab-pane label="화면" :name="DashboardConst.WIDGET_SET_TYPE.VIEW"></el-tab-pane>
      </el-tabs>
      <el-scrollbar ref="scrollbar" style="height: calc(100% - 61px);">
        <el-collapse class="menu-wrapper" v-model="activeTempl" accordion>
          <el-collapse-item v-for="templ in widgetTempl" :key="templ.widgetTemplId" :name="templ.widgetTemplId" :title="getCollapseTitle(templ)" :class="visibleCollapseItem(templ.widgetTemplId) ? '' : $style['collapse-item-hide']">
            <component :is="widgetSettingView(templ.widgetTemplId)" ref="settingWidget" @hook:created="onCreatedSettingView(templ.widgetTemplId)" :widget-list="activeWidgetGroupByTempl[templ.widgetTemplId]" :active-tab="activeTab"/>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { filter, forEach, isEmpty } from 'lodash';

import DashboardConst from '@/constants/dashboard';
import Base from '@/mixins/dashboard/base';

export default {
  name: 'WDashboardWidgetSettingSide',
  mixins: [Base],
  components: {
  },
  data() {
    return {
      DashboardConst,
      activeTab: DashboardConst.WIDGET_SET_TYPE.BASE,
      activeWidgets: [],
      activeWidgetTempls: {},
      activeWidgetGroupByTempl: {},
      activeTempl: null,
      cachedComponent: {},
    };
  },
  computed: {
    /**
     * 위젯 설정화면 컴포넌트 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    widgetSettingView() {
      return (widgetTemplId) => {
        if (this.activeTempl === widgetTemplId || this.cachedComponent[widgetTemplId]) {
          return this.$store.getters.getWidgetSettingComponent[widgetTemplId];
        }
        return null;
      };
    },
    /**
     * 아코디언 탭 표현 여부
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    visibleCollapseItem() {
      return (widgetTemplId) => {
        if (this.activeWidgetTempls[widgetTemplId]) {
          return true;
        }
        return false;
      };
    },
    /**
     * 아코디언 탭 타이틀 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    getCollapseTitle() {
      return (templ) => {
        let title = templ.widgetTemplName;

        if (this.activeWidgetGroupByTempl[templ.widgetTemplId]) {
          title += ` (${this.activeWidgetGroupByTempl[templ.widgetTemplId].length})`;
        }
        return title;
      };
    },
  },
  watch: {
    activeTab() {
      // 탭 변경 후 설정화면 스크롤을 최상단으로 이동시킨다.
      this.$nextTick(() => {
        this.$refs.scrollbar.$refs.wrap.scrollTop = 0;
      });
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.WIDGET_ACTIVE_CHANGE, this.onActiveWidgetChange);

    this.onActiveWidgetChange();
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.WIDGET_ACTIVE_CHANGE, this.onActiveWidgetChange);
  },
  methods: {
    /**
     * <keep-alive>
     *  <component :is="widgetSettingView(templ.widgetTemplId)" ref="settingWidget"/>
     * </keep-alive>
     * 이렇게 할 경우 캐싱은 되지만 아코디언이 확장 되는 순간 캐싱 된 컴포넌트가 inactive -> active 로 변경되면서 잠시 프리징 되는 현상이 발생하여
     * 한번 생성 된 컴포넌트를 inactive 되지 않고 항상 active 상태로 유지시키기 위한 조치이다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} widgetTemplId [description]
     * @return {[type]}               [description]
     */
    onCreatedSettingView(widgetTemplId) {
      this.cachedComponent[widgetTemplId] = widgetTemplId;
    },
    /**
     * 위젯 선택 상태 변경
     * 위젯이 선택 상태가 되거나 미선택 상태로 변하면 호출된다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onActiveWidgetChange() {
      let tmpActiveWidgets = [];
      const tmpActiveWidgetTempls = {};
      const tmpActiveWidgetGroupByTempl = {};

      tmpActiveWidgets = filter(this.widgetLayout, ['active', true]);

      forEach(tmpActiveWidgets, (widget) => {
        tmpActiveWidgetTempls[widget.widgetTemplId] = widget.widgetTemplId;

        if (!tmpActiveWidgetGroupByTempl[widget.widgetTemplId]) {
          tmpActiveWidgetGroupByTempl[widget.widgetTemplId] = [];
        }
        tmpActiveWidgetGroupByTempl[widget.widgetTemplId].push(this.dashboardWidget[widget.i]);
      });

      this.activeWidgets = tmpActiveWidgets;
      this.activeWidgetTempls = tmpActiveWidgetTempls;
      this.activeWidgetGroupByTempl = tmpActiveWidgetGroupByTempl;

      // 첫번째 아코디언 확장
      this.$nextTick(() => {
        if (!isEmpty(this.activeWidgetTempls)) {
          forEach(this.widgetTempl, (templ) => {
            if (this.activeWidgetTempls[templ.widgetTemplId]) {
              this.activeTempl = templ.widgetTemplId;
              return false;
            }
            return true;
          });
        } else {
          this.activeTempl = null;
        }
      });
    },
  },
};
</script>

<style module>
.wrapper {
  height: 100%;
  width: 100%;
  padding: 0px 20px;
}
.no-data {
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 13px;
  color: #434d6b;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.collapse-item-hide {
  display: none;
}


</style>
<style lang="scss">
.dashboard-widget-setting-side {
  .el-collapse-item__header {
    padding-left: 5px;
  }
  .el-scrollbar__view {
    width: calc(100% - 10px) !important;
  }

  /* 탭 스타일 시작 */
  .el-tabs__item {
    color: #888;
  }
  .el-tabs__content {
      min-height: 0px;
  }
  .el-tabs__item.is-active,
  .el-tabs__item:active,
  .el-tabs__item:focus,
  .el-tabs__item:hover {
    color: #333;
  }
  .el-tabs__active-bar {
    background-color: #555 !important;
  }
  /* 탭 스타일 끝 */
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/DashboardWidgetSettingSide.vue